<template>
	<ul
		class="ul--nostyling button-list grid"
		role="group"
		:aria-label="ariaLabelFilterOnYears"
	>
		<li class="col-auto" v-for="filter in visibleFilters" :key="filter">
			<label class="button-switch">
				<input
					type="checkbox"
					:value="parseInt(filter)"
					v-model="activeFilters"
					@change="onCheckboxChange($event)"
				/>
				<span class="button-switch__button">{{ filter }}</span>
			</label>
		</li>
	</ul>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';

const props = defineProps({
  chosenFilters: Array,
  filters: Array,
  ariaLabelFilterOnYears: String
});

const emit = defineEmits(['update']);

const activeFilters = ref([]);
const visibleFilters = computed(() =>
	(props.filters ?? []).filter(
		(filter) =>
			filter !== null &&
			filter !== undefined &&
			String(filter).trim() !== '' &&
			Number.isInteger(Number(filter))
	)
);

onMounted(() => {
  activeFilters.value = props.chosenFilters;
});

const onCheckboxChange = (evt) => {
  emit('update', activeFilters.value);
};


</script>
